import { Component, OnInit, Pipe, PipeTransform, HostListener, OnDestroy, Directive } from '@angular/core';
import { HelperService } from '../../../../../src/app/services/helper/helper.service';
import { EnvironmentService } from '../../../../../src/app/services/environment.service';
import { Subscription } from 'rxjs';
import * as UserTypeModels from "../../../models/user-types/user-types";
import * as OrderModels from '../../../models/order/order';
@Directive()
export abstract class BaseComponent implements OnDestroy {

  constructor(public helperService: HelperService, public environmentService: EnvironmentService
  ) {

    const user = JSON.parse(localStorage.getItem('currentUser'));

    if (user) {

      if (user.UserTypeId == UserTypeModels.UserTypes.Administration) {

        this.IsAdministrationSite = true;

      } else if (user.UserTypeId ==  UserTypeModels.UserTypes.Service) {

        this.IsServiceSite = true;

      } else if (user.UserTypeId == UserTypeModels.UserTypes.Customer) {

        this.IsCustomerSite = true;

      } 
    }

  }

  public subscription: Subscription = new Subscription();

  public url: string = this.environmentService.oldAppURL;

  public application: string = this.environmentService.appName;

  public isLoading: boolean = true;

  public IsServiceSite: boolean = false;

  public IsCustomerSite: boolean = false;

  public IsAdministrationSite: boolean = false;

  ngOnDestroy(): void {

    this.subscription.unsubscribe();
  }

  public YesNo = [
    { value: true, label: 'Tak' },
    { value: false, label: 'Nie' },
  ];

  public Quantity = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
  ];

  public Period = [
    { value: 1, label: 'Miesięczny' },
    { value: 3, label: 'Kwartalny' },
    { value: 6, label: 'Półroczny' },
    { value: 12, label: 'Roczny' }
  ];

  public AvailableDataRange = {
    items: [
      { label: 'Dzisiaj', value: 0 },
      { label: 'Wczoraj', value: 1 },
      { label: 'Aktualny miesiąc', value: 2 },
      { label: 'Poprzedni miesiąc', value: 3 },
      { label: 'Wybrany zakres', value: 4 },
      { label: 'Aktualny rok', value: 5 }
    ]
  };


  public DepositeSize = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' }
  ];

  public GarageVisitTimeSlots = [
    { value: 1, label: '1' },
    { value: 2, label: '2' }
  ];

  ///Zmienna pomocnicza wykorzystywana przy dialogach potwierdzających p-confirmDialog
  public confirmDialogVisible: boolean = false;
  public confirmDialogKey: string = "confirm-dialog";
  public confirmDialogDefaultHeder = "Potwierdzenie akcji";
  public confirmDialogAcceptLabel: string = "Tak";
  public confirmDialogRejectLabel: string = "Nie";

  public confirmDialogVisible2: boolean = false;
  public confirmDialogKey2: string = "confirm-dialog-2";
  public confirmDialogDefaultHeder2 = "Potwierdzenie akcji";
  public confirmDialogAcceptLabel2: string = "Tak";
  public confirmDialogRejectLabel2: string = "Nie";

  public messageDialogVisible: boolean = false;

  onHideMessageDialog(event: any) {
    this.messageDialogVisible = false;
  }


  public downloadDataURL(uri, fileName) {
    var link = document.createElement("a");
    link.download = fileName;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
  }

  calculateBadgesClasses(Order: OrderModels.OrderPreviewModel) {
    return {
      'badge-success': !Order.IsSpecificationActive && !Order.IsCancel,
      'badge-warning': Order.IsSpecificationActive && !Order.IsCancel,
      'badge-secondary': Order.IsCancel
    };
  }
}
